import { render } from "./ShowPaymentSmall.vue?vue&type=template&id=65edd6cb&scoped=true"
import script from "./ShowPaymentSmall.vue?vue&type=script&lang=js"
export * from "./ShowPaymentSmall.vue?vue&type=script&lang=js"

import "./ShowPaymentSmall.vue?vue&type=style&index=0&id=65edd6cb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65edd6cb"]])

export default __exports__